<script>
    import { addRole } from '@/api/user.js';

    export default {
        computed: {
            isSaveAdd() {return this.$store.getters.IS_SAVE_ROLE_ADD},
            permission() {return this.$store.getters.CONST_PERMISSIONS},
        },
        methods: {
            async create() {
                const response = await addRole(
                    this.$store.getters.ROLE_ADD_DATA
                );
                if (response != null) {
                    this.$store.commit('ROLES_ADD', response);
                }
            },
            async clear() {
                this.permission.forEach((permissionValue, permissionIndex) => {
                    this.$store.commit('ROLE_ADD_UPDATE', {
                        fieldName: permissionValue['id'],
                        fieldValue: false,
                    });
                });
                this.$store.dispatch('CHECK_ROLE_ADD');
            },
            async close() {
                this.$store.commit('IS_SHOW_ROLE_ADD', false);
            }
        }
    }
</script>


<template>
    <div>
        <button
            :disabled="isSaveAdd === false"
            class="button_blue_100"
            @click="create"
        >Create</button>
        <button
            class="button_blue_100 ml_10"
            @click="clear"
        >Clear Permission</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>